// Locale Getters

export const isRtl = state => {
  return state.isRtl
}

export const getCurrentLocale = state => {
  return state.currentLocale
}

export const getLocales = state => {
  return state.locales
}

export const getCountriesList = state => {
  return state.countriesList
}
